import React, { useState, useEffect } from "react";
import _ from "lodash";

import { useDispatch, useSelector } from "react-redux";
import HeaderFinwell from "../components/HeaderFinwell";
import FooterFinwell from "../components/FooterFinwell";
import useLogin from "../../custom-hooks/useLogin";
import Loader from "../../components/Loader/Loader";
import SideMenuFinwell from "../components/SideMenuFinwell";

const Page = (props) => {
  const { showSideMenu=true } = props;
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = React.useState(true);
  const [smartBarData, setSmartBarData] = useState();
  const showDropDownRes = useSelector(
    (state) => state.assignCourse.showDropDownRes
  );
  const showMoreMenuRes = useSelector(
    (state) => state.assignCourse.showMoreMenuRes
  );
  const authBroker = useSelector((state) => state.auth.authBroker);
  const getSmartBarResponse = useSelector((state) => state.home.smartBar);
  const userRole = useSelector((state) => state.user.role)
  const { isLoggedIn } = useLogin();

  const [config,setConfig] = useState({});

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
        console.log("authBroker: ",authBroker)
        if (!_.isEmpty(authBroker.payload.user.role)) {
            setConfig(authBroker.payload.user.config)
        }else{
          setConfig({})
        }
    }else{
      setConfig({})
    }
}, [authBroker])

  useEffect(() => {
    if (!_.isEmpty(getSmartBarResponse)) {
      setIsLoading(false);
      if (getSmartBarResponse.status === "success") {
        setSmartBarData(getSmartBarResponse?.payload?.payload);
      }
    }
  }, [getSmartBarResponse]);

const [isSidebarOpen, setSidebarOpen] = useState(false);

const toggleSidebar = () => setSidebarOpen(prev => !prev);
  return (
    <div id='idForTour' className="page-wrapper-rsp">
      <div
        id="idParent"
        className="rspinnerwrapper"
      >
        <HeaderFinwell showMenu={isSidebarOpen} toggleSidebar={toggleSidebar} />
         <SideMenuFinwell isOpen={isSidebarOpen} toggle={showSideMenu} />
        <div className={"main"}>
          {authBroker?.payload?.user?.is_personate ===1 && <div className="impersonation-banner">
            <div className="containersd">
              <div className="row">
                <div className="col-md-12 d-flex justify-content-between gap-2 align-items-center">
                  <div className="impersonation-text">
                    <span className="impersonation-text-span me-2">
                      <svg xmlns="http://www.w3.org/2000/svg" className="svg-icon"  style={{width: '22px', height: '22px', verticalAlign: 'middle', fill: 'currentColor', overflow: 'hidden'}} viewBox="0 0 1280 1024" version="1.1"><path d="M1221 746.6c5.2-28.2 5.2-57 0-85.2l51.6-29.8c6-3.4 8.6-10.4 6.6-17-13.4-43.2-36.4-82.4-66.4-114.8-4.6-5-12-6.2-18-2.8l-51.6 29.8c-21.8-18.6-46.8-33-73.8-42.6v-59.6c0-6.8-4.8-12.8-11.4-14.2-44.6-10-90-9.6-132.4 0-6.6 1.4-11.4 7.4-11.4 14.2v59.6c-27 9.6-52 24-73.8 42.6l-51.6-29.8c-5.8-3.4-13.4-2.2-18 2.8-30 32.4-53 71.6-66.4 114.8-2 6.6 0.8 13.6 6.6 17l51.6 29.8c-5.2 28.2-5.2 57 0 85.2l-51.6 29.8c-6 3.4-8.6 10.4-6.6 17 13.4 43.2 36.4 82.2 66.4 114.8 4.6 5 12 6.2 18 2.8l51.6-29.8c21.8 18.6 46.8 33 73.8 42.6v59.6c0 6.8 4.8 12.8 11.4 14.2 44.6 10 90 9.6 132.4 0 6.6-1.4 11.4-7.4 11.4-14.2v-59.6c27-9.6 52-24 73.8-42.6l51.6 29.8c5.8 3.4 13.4 2.2 18-2.8 30-32.4 53-71.6 66.4-114.8 2-6.6-0.8-13.6-6.6-17l-51.6-29.8zM992 801c-53.6 0-97-43.6-97-97s43.6-97 97-97 97 43.6 97 97-43.4 97-97 97zM448 512c141.4 0 256-114.6 256-256S589.4 0 448 0 192 114.6 192 256s114.6 256 256 256z m402.4 453c-4.6-2.4-9.2-5.2-13.6-7.8l-15.8 9.2c-12 6.8-25.6 10.6-39.2 10.6-21.8 0-42.8-9.2-57.8-25.2-36.6-39.6-64.6-87.8-80.4-139.2-11-35.4 3.8-72.8 35.8-91.4l15.8-9.2c-0.2-5.2-0.2-10.4 0-15.6l-15.8-9.2c-32-18.4-46.8-56-35.8-91.4 1.8-5.8 4.4-11.6 6.4-17.4-7.6-0.6-15-2.4-22.8-2.4h-33.4c-44.4 20.4-93.8 32-145.8 32s-101.2-11.6-145.8-32h-33.4C120.4 576 0 696.4 0 844.8V928c0 53 43 96 96 96h704c20.2 0 39-6.4 54.4-17-2.4-7.6-4-15.4-4-23.6v-18.4z" fill="#415385"></path></svg>
                    </span>
                    <strong>Coach Access Active</strong>
                    <span className="impersonation-user-name">- {authBroker?.payload?.user?.firstname? authBroker?.payload?.user?.firstname+" " : ""}{authBroker?.payload?.user?.lastname} Session.</span>
                  </div>

                  {/* <div className="butso">
            <a href="" className="primary-button">Stop Impersonation</a>
          </div> */}
                </div>
              </div>
            </div>
          </div>}
          <div className="child-sec">
            {props.children}
            </div>
           {!props.hideFooter && <FooterFinwell />}
        </div>
      </div>
     
    </div>
  );
};

export default Page;
